"use client";

import React from "react";
import { Wifi, Briefcase, Coffee, Shield, Car, Utensils, Sparkles, Clock, Tv, Bed, MapPin, Users } from "lucide-react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const tabsData = [{
  id: "business",
  label: "Business"
}, {
  id: "contractors",
  label: "Contractors"
}, {
  id: "leisure",
  label: "Leisure"
}];
const amenitiesData = [{
  tabId: "business",
  label: "Enterprise-grade Wi-Fi",
  icon: Wifi
}, {
  tabId: "business",
  label: "Dedicated workspace",
  icon: Briefcase
}, {
  tabId: "business",
  label: "Artisan coffee machine",
  icon: Coffee
}, {
  tabId: "business",
  label: "24/7 priority support",
  icon: Shield
}, {
  tabId: "contractors",
  label: "Secure on-site parking",
  icon: Car
}, {
  tabId: "contractors",
  label: "Fully equipped kitchen",
  icon: Utensils
}, {
  tabId: "contractors",
  label: "Weekly deep cleaning",
  icon: Sparkles
}, {
  tabId: "contractors",
  label: "Flexible check-in times",
  icon: Clock
}, {
  tabId: "leisure",
  label: "Smart TV & Entertainment",
  icon: Tv
}, {
  tabId: "leisure",
  label: "Premium hotel linens",
  icon: Bed
}, {
  tabId: "leisure",
  label: "Prime central locations",
  icon: MapPin
}, {
  tabId: "leisure",
  label: "Family-friendly amenities",
  icon: Users
}];
export default function TailoredForYourTrip() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="tailored-for-your-trip" className="bg-background py-24 md:py-48 overflow-hidden" ref={sectionRef}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 lg:gap-8 items-center">
          
          {}
          <div className={`lg:col-span-6 relative transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            {}
            <div className="absolute -top-3 -left-3 w-5 h-5 border-t-2 border-l-2 border-secondary z-10" aria-hidden="true" />
            
            <div className="relative aspect-[4/5] md:aspect-square lg:aspect-[4/5] overflow-hidden bg-muted">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1692125/img/workspace_high_key.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1692125/img/workspace_high_key.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1692125/img/workspace_high_key.png-wvc-sizes" alt="High-key bright workspace in a serviced accommodation" className="w-full h-full object-cover transition-transform duration-[1.2s] ease-out hover:scale-105" loading="lazy" decoding="async" />
            </div>
          </div>

          {}
          <div className={`lg:col-span-6 flex flex-col justify-center pl-4 sm:pl-8 lg:pl-12 transition-all duration-1000 delay-100 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            {}
            <h2 className="font-default text-[clamp(2.5rem,5vw,3.5rem)] font-normal tracking-tight leading-[1.1] mb-12 text-foreground">
              <span className="block -ml-4 sm:-ml-8 text-secondary">Tailored</span>
              <span className="block">for Your Trip</span>
            </h2>

            <Tabs defaultValue="business" className="w-full">
              <TabsList className="bg-transparent p-0 h-auto w-full justify-start border-b border-border mb-8 gap-6 sm:gap-8 flex-wrap">
                {tabsData.map((tab, i) => <TabsTrigger key={tab.id} data-index={i} value={tab.id} className="border-b-2 border-transparent data-[state=active]:border-secondary data-[state=active]:bg-transparent px-0 py-3 text-base sm:text-lg font-medium text-muted-foreground data-[state=active]:text-foreground transition-colors hover:text-foreground">
                    {tab.label}
                  </TabsTrigger>)}
              </TabsList>

              {tabsData.map((tab, i) => <TabsContent key={tab.id} data-index={i} value={tab.id} className="mt-0 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2">
                  <ul className="space-y-6">
                    {amenitiesData.filter(amenity => amenity.tabId === tab.id).map((amenity, j) => <li key={j} data-index={j} className="flex items-center gap-4 group">
                          <div className="flex-shrink-0 w-10 h-10 flex items-center justify-center bg-muted/50 group-hover:bg-muted transition-colors">
                            <amenity.icon className="w-5 h-5 text-muted-foreground stroke-[1.5pt] group-hover:text-foreground transition-colors" />
                          </div>
                          <span className="font-sans text-lg text-foreground font-light tracking-wide">
                            {amenity.label}
                          </span>
                        </li>)}
                  </ul>
                </TabsContent>)}
            </Tabs>
          </div>

        </div>
      </div>
    </section>;
}